<template>
  <div>
    <a-card size="small" class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item label="名称"><a-input v-model="filterForm.name" @change="getTagList" /> </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <div class="filter-action">
              <a-button type="primary" @click="getTagList">查询</a-button>
              <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="标签列表" size="small" class="tag-list">
      <a-button slot="extra" v-has="{ code: 'system:tag:add', project: 0 }" type="link" icon="plus" @click="onAdd"> 添加 </a-button>
      <a-table :pagination="pagination" :columns="columns" :loading="loading" size="middle" :data-source="tagItems" row-key="id" @change="handleTableChange">
        <span slot="tag" slot-scope="text, record">
          <a-tag :color="record.color">{{ record.name }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:tag:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:tag:delete', project: 0 }" @click="onDelete(record)">删除</a>
        </span>
      </a-table>
    </a-card>
    <tag-modal ref="tagModalRef" @ok="close" />
  </div>
</template>

<script>
import { tagList, tagDelete } from '@/api/system/tag';
import TagModal from '@/pages/system/tags/components/TagModal';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '5%',
    align: 'center'
  },
  {
    title: '名称',
    width: '25%',
    align: 'center',
    scopedSlots: { customRender: 'tag' }
  },
  {
    title: '分类',
    dataIndex: 'group_name',
    key: 'group_name',
    width: '20%',
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: '20%',
    align: 'center'
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    width: '20%',
    align: 'center'
  },
  {
    title: '操作',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: {
    TagModal
  },
  props: {
    groupId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      loading: false,
      tagItems: [],
      filterForm: {
        title: null,
        group_id: null,
        page_number: 1,
        page_size: 10
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },

  watch: {
    groupId() {
      this.filterForm.group_id = this.groupId;
      this.getTagList();
    }
  },

  created() {
    this.getTagList();
  },

  methods: {
    getTagList() {
      this.loading = true;
      tagList(this.filterForm)
        .then(res => {
          this.tagItems = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDelete(tag) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这个标签吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          tagDelete({ id: tag.id }).then(() => {
            self.$message.success('删除成功');
            self.getTagList();
          });
        }
      });
    },

    onAdd() {
      this.$nextTick(() => {
        this.$refs.tagModalRef.open(null, { group_id: this.groupId });
      });
    },

    onEdit(tag) {
      this.$refs.tagModalRef.open(tag.id, tag);
    },

    onReset() {
      this.filterForm.title = null;
      this.getTagList();
    },

    close() {
      this.getTagList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getTagList();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  margin-bottom: 16px;
  .ant-form-item {
    margin: 8px 0;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
  .filter-action {
    margin: 8px 0;
  }
}

/deep/.tag-list {
  .ant-card-body {
    overflow: scroll;
    height: calc(~'100vh - 288px');
  }
}
</style>
